import { Link } from "react-router-dom";
import BrandLogo from "@/components/BrandLogo";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-white/5 bg-[#080808]">
      <div className="max-w-6xl mx-auto px-6 sm:px-10 py-16 grid md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2 mb-4">
            <BrandLogo />
            <span className="font-serif-editorial text-xl tracking-tight">HustlrMate</span>
          </div>
          <p className="text-sm text-[#A1A1AA] font-light max-w-sm leading-relaxed">
            The commitment layer for people who are done drifting. Get paired. Show up. Compound.
          </p>
        </div>

        <div>
          <div className="overline mb-4">Product</div>
          <ul className="space-y-2 text-sm text-[#A1A1AA] font-light">
            <li><a href="/#features" className="hover:text-[#F5F5F0]">Features</a></li>
            <li><a href="/#pricing" className="hover:text-[#F5F5F0]">Pricing</a></li>
            <li><a href="/#how" className="hover:text-[#F5F5F0]">How it works</a></li>
            <li><Link to="/auth" className="hover:text-[#F5F5F0]">Sign up</Link></li>
            <li><Link to="/creators" className="hover:text-[#F5F5F0]">Creator program</Link></li>
            <li><Link to="/shield/about" className="hover:text-[#F5F5F0]">How the Shield works</Link></li>
          </ul>
        </div>

        <div>
          <div className="overline mb-4">Policies</div>
          <ul className="space-y-2 text-sm text-[#A1A1AA] font-light">
            <li><Link to="/terms-and-conditions" className="hover:text-[#F5F5F0]">Terms and Conditions</Link></li>
            <li><Link to="/privacy-policy" className="hover:text-[#F5F5F0]">Privacy Policy</Link></li>
            <li><Link to="/shipping-policy" className="hover:text-[#F5F5F0]">Shipping Policy</Link></li>
            <li><Link to="/cancellation-and-refunds" className="hover:text-[#F5F5F0]">Cancellation and Refunds</Link></li>
            <li><Link to="/contact-us" className="hover:text-[#F5F5F0]">Contact Us</Link></li>
            <li><Link to="/delete-account" className="hover:text-[#F5F5F0]">Delete your account</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/5">
        <div className="max-w-6xl mx-auto px-6 sm:px-10 py-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <span className="text-xs text-[#A1A1AA] font-light">© {new Date().getFullYear()} HustlrMate. Built for the ones who show up.</span>
          <span className="text-xs text-[#A1A1AA] font-light tracking-[0.2em] uppercase">Discipline · Compounded</span>
        </div>
      </div>
    </footer>
  );
}
